/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Select from "react-select";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Importa o CSS do calendÃ¡rio
import { ptBR } from "date-fns/locale";
import "../css/dashboard.css";
import "../css/boletos.css";
import logo from "../images/logo_fundo_branco.png";
import BoletoService from "../../modules/services/BoletoService";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { FaChevronLeft, FaChevronRight, FaChevronDown } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { BsCopy } from "react-icons/bs";
import { formatCNPJ } from '../../utils/format';

const isDeposito = (boleto) => Number(boleto.cdBanco) === 0;

const boletoDisponivelParaDownload = (boleto) => !isDeposito(boleto);

const TOOLTIP_PIX_DEPOSITO = "Pix copia e cola indisponível para títulos com forma de pagamento Depósito.";
const TOOLTIP_LINHA_DEPOSITO = "Linha digitável indisponível para títulos com forma de pagamento Depósito.";
const TOOLTIP_CHECKBOX_DEPOSITO = "Download indisponível para títulos com forma de pagamento Depósito, pois não há boleto gerado.";

function Boletos({ cliente }) {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const codigoCliente = cliente.cdCliente;
    let filtroSituacao = location.state?.situacaoIn;
    //console.log("cliquei aqui" + filtroSituacao);
    // Função utilitária para garantir que a data seja sempre um objeto Date ou null
    const parseToDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return value;
        const d = new Date(value);
        return isNaN(d) ? null : d;
    };
    // Se houver filtro, usa ele
    const filtroVencendoAmanhaDe = parseToDate(location.state?.dtVencimentoDe) || null;
    const filtroVencendoAmanhaAte = parseToDate(location.state?.dtVencimentoAte) || null;
    const [showDateModal, setShowDateModal] = useState(false);
    const [showVencimentoModal, setShowVencimentoModal] = useState(false);

    const [boletos, setBoletos] = useState([]);
    const [selectedBoletos, setSelectedBoletos] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 15;

    const convertDateToString = (date, isEndOfDay = false) => {
        if (date instanceof Date && !isNaN(date)) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}T${isEndOfDay ? '23:00:00.000Z' : '00:00:00.000Z'}`;
        }
        return null;
    };

    const options = [
        { value: "AVENCER", label: "A VENCER" },
        { value: "PAGO", label: "PAGO" },
        { value: "VENCIDO", label: "VENCIDO" },
    ];

    if (Array.isArray(filtroSituacao) && typeof filtroSituacao[0] === 'number') {
        filtroSituacao = [options[filtroSituacao[0]]?.value];
    }
    if (typeof filtroSituacao === 'string') {
        filtroSituacao = [filtroSituacao];
    }
    if (!filtroSituacao) {
        filtroSituacao = ["AVENCER"];
    }

    const [filtros, setFiltros] = useState({
        situacaoIn: filtroSituacao,
        fatorOrdenacao: "ASC",
        orderBy: "DT_VENCIMENTO",
        dtVencimentoDe: filtroVencendoAmanhaDe,
        dtVencimentoAte: filtroVencendoAmanhaAte,
        dtEmissaoDe: null,
        dtEmissaoAte: null,
    });
    //console.log("depois do filtro ", filtroSituacao.label);

    console.log('Renderizando Boletos. Filtros atuais:', filtros);
    console.log('Renderizando Boletos. Boletos atuais:', boletos);

    const fetchBoletosInfo = async () => {
        console.log('Iniciando fetchBoletosInfo');
        setBoletos('');
        setIsLoading(true);
        const filtrosFormatados = {
            ...filtros,
            dtEmissaoDe: convertDateToString(filtros.dtEmissaoDe),
            dtEmissaoAte: convertDateToString(filtros.dtEmissaoAte, true),
            dtVencimentoDe: convertDateToString(filtros.dtVencimentoDe),
            dtVencimentoAte: convertDateToString(filtros.dtVencimentoAte, true),
        };
        console.log('fetchBoletosInfo - filtrosFormatados:', filtrosFormatados);
        try {
            const response = await BoletoService.getListaBoletos(
                codigoCliente,
                filtrosFormatados
            );
            console.log('fetchBoletosInfo - resposta da API:', response);
            setBoletos(response || []);
        } catch (err) {
            console.error('Erro ao buscar boletos:', err);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        console.log('useEffect location.state', location.state);
        if (location.state) {
            setFiltros((prevFiltros) => {
                const novosFiltros = {
                    ...prevFiltros,
                    dtVencimentoDe: parseToDate(location.state.dtVencimentoDe) ?? prevFiltros.dtVencimentoDe,
                    dtVencimentoAte: parseToDate(location.state.dtVencimentoAte) ?? prevFiltros.dtVencimentoAte,
                    situacaoIn: location.state.situacaoIn || prevFiltros.situacaoIn,
                };
                console.log('setFiltros via location.state:', novosFiltros);
                return novosFiltros;
            });
        }
    }, [location.state]);
    useEffect(() => {
        console.log('useEffect filtros/codigoCliente', filtros, codigoCliente);
        fetchBoletosInfo();
    }, [codigoCliente, filtros]);

    const handleOrdenacaoChange = (event) => {
        const ordenacao = event.target.value;
        //console.log(ordenacao);
        if (ordenacao === "Ordenacao") {
            setFiltros({
                ...filtros,
                orderBy: "DT_VENCIMENTO",
                fatorOrdenacao: "DESC",
            });
        } else {
            const [orderBy, fatorOrdenacao] = ordenacao.split(","); // Separando os valores
            setFiltros((prevFiltros) => ({
                ...prevFiltros,
                orderBy: orderBy, // Atribuindo o primeiro valor
                fatorOrdenacao: fatorOrdenacao, // Atribuindo o segundo valor
            }));
        }
    };

    const handleSort = (column) => {
        const isAsc = filtros.orderBy === column && filtros.fatorOrdenacao === 'ASC';
        setFiltros({
            ...filtros,
            orderBy: column,
            fatorOrdenacao: isAsc ? 'DESC' : 'ASC',
        });
    };

    // FunÃ§Ã£o para atualizar o filtro de situaÃ§Ã£o
    const handleSituacaoChange = (event) => {
        setBoletos('');
        const situacao = event.map((option) => option.value);
        console.log('handleSituacaoChange - novo situacaoIn:', situacao);
        setFiltros((prevFiltros) => {
            const novosFiltros = {
                ...prevFiltros,
                situacaoIn: situacao,
            };
            console.log('setFiltros via handleSituacaoChange:', novosFiltros);
            return novosFiltros;
        });
    };

    // FunÃ§Ã£o para atualizar o valor de Nota Fiscal
    const handleNfeChange = (event) => {
        const nrNfe = event.target.value;
        console.log('handleNfeChange - novo nrNfeIn:', nrNfe);
        setFiltros((prevFiltros) => {
            const novosFiltros = {
                ...prevFiltros,
                nrNfeIn: nrNfe,
            };
            console.log('setFiltros via handleNfeChange:', novosFiltros);
            return novosFiltros;
        });
    };

    // FunÃ§Ã£o para atualizar o valor de Nota Fiscal
    const handleBoletoChange = (event) => {
        const nrBoleto = event.target.value;
        console.log('handleBoletoChange - novo nrDuplicataIn:', nrBoleto);
        setFiltros((prevFiltros) => {
            const novosFiltros = {
                ...prevFiltros,
                nrDuplicataIn: nrBoleto,
            };
            console.log('setFiltros via handleBoletoChange:', novosFiltros);
            return novosFiltros;
        });
    };

    const handleDateChange = (date, field) => {
        console.log('handleDateChange - campo:', field, 'data:', date);
        setFiltros((prevFiltros) => {
            const novosFiltros = {
                ...prevFiltros,
                [field]: date || null,
            };
            console.log('setFiltros via handleDateChange:', novosFiltros);
            return novosFiltros;
        });
    };
    const handleOpenDateModal = () => setShowDateModal(true);
    const handleCloseDateModal = () => setShowDateModal(false);

    const handleOpenVencimentoModal = () => setShowVencimentoModal(true);
    const handleCloseVencimentoModal = () => setShowVencimentoModal(false);

    const clearDateFilter = (fieldStart, fieldEnd) => {
        setFiltros((prevFiltros) => ({
            ...prevFiltros,
            [fieldStart]: null,
            [fieldEnd]: null,
        }));
        handleCloseDateModal();
        handleCloseVencimentoModal();
    };

    const applyDateFilter = () => {
        handleCloseDateModal();
        // Não chame fetchBoletosInfo() aqui!
    };

    const applyVencimentoFilter = () => {
        handleCloseVencimentoModal();
        // Não chame fetchBoletosInfo() aqui!
    };
    // FunÃ§Ãµes de manipulaÃ§Ã£o de seleÃ§Ã£o e download de boletos (mantidas inalteradas)
    const handleSelectBoleto = (index) => {
        setSelectedBoletos((prevSelected) =>
            prevSelected.includes(index)
                ? prevSelected.filter((item) => item !== index)
                : [...prevSelected, index]
        );
    };

    const indicesBoletosDisponiveis = () =>
    (Array.isArray(boletos) ? boletos : [])
        .map((boleto, index) =>
            boletoDisponivelParaDownload(boleto) ? index : null
        )
        .filter((index) => index !== null);

    const handleSelectAllBoletos = (event) => {
        setSelectedBoletos(
            event.target.checked ? indicesBoletosDisponiveis() : []
        );
    };

    const copiarLinhaDigitavel = (linha) => {
        if (linha) {
            navigator.clipboard
                .writeText(linha)
                .then(() =>
                    alert("Linha digitável copiado para a área de transferência!")
                )
                .catch((err) =>
                    console.error("Erro ao copiar a linha digitável: ", err)
                );
        }
    };

    const copiarQrCode = (qrCode) => {
        if (qrCode) {
            navigator.clipboard
                .writeText(qrCode)
                .then(() =>
                    alert("QR Code copiado para a área de transferência!")
                )
                .catch((err) =>
                    console.error("Erro ao copiar o QR Code: ", err)
                );
        }
    };

    const visualizarBoleto = async (boleto) => {
        console.log("clicou para abrir o modal exibindo o boleto")
        setIsModalLoading(true);
        setModalContent('');
        setIsModalOpen(true);
        try {
            const blob = await BoletoService.getVisualizarBoleto(
                boleto.nrDuplicata,
                boleto.cdEmpresa
            );
            const url = URL.createObjectURL(blob);

            // Detecta dispositivo móvel
            const isMobile = /iPhone|iPad|iPod|Android/i.test(
                navigator.userAgent
            );

            if (isMobile) {
                // Abre o PDF em uma nova aba no celular
                window.open(url, "_blank");
            } else {
                // Exibe o PDF no modal em dispositivos não móveis
                setModalContent(url);
                setIsModalOpen(true);
            }
        } catch (error) {
            console.error("Erro ao visualizar o boleto:", error);
            alert("Erro ao carregar o boleto.");
        } finally {
            setIsModalLoading(false); // Finaliza o carregamento quando o conteúdo estiver pronto
            setIsModalOpen(true); // Abre o modal
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent("");
        if (modalContent) {
            URL.revokeObjectURL(modalContent);
        }
    };

    const baixarBoletosSelecionados = async () => {
        const boletosParaBaixar = selectedBoletos.filter(
            (index) => boletoDisponivelParaDownload(boletos[index])
        );

        if (boletosParaBaixar.length === 0) {
            alert("Selecione pelo menos um boleto para baixar.");
            return;
        }
        try {
            for (const index of boletosParaBaixar) {
                const boleto = boletos[index];
                const blob = await BoletoService.getVisualizarBoleto(
                    boleto.nrDuplicata,
                    boleto.cdEmpresa
                );
                const url = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = `${boleto.nrDuplicata}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("Erro ao baixar os boletos:", error);
            alert("Erro ao baixar os boletos.");
        }
    };

    const toggleRow = (index) => {
        setExpandedRows((prevExpanded) =>
            prevExpanded.includes(index)
                ? prevExpanded.filter((i) => i !== index)
                : [...prevExpanded, index]
        );
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = boletos.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(boletos.length / recordsPerPage);

    const goToPage = (page) => setCurrentPage(page);

    const [isModalLoading, setIsModalLoading] = useState(true); // Novo estado para controle do carregamento no modal

function formatTelefone(numero) {
    if (!numero) return '';
    // Remove tudo que não for número
    const tel = numero.replace(/\D/g, '');
    // Se tiver DDI (ex: 55), remove e formata normalmente
    let ddi = '';
    let ddd = '';
    let num = '';
    if (tel.length > 11) {
        ddi = '+' + tel.slice(0, tel.length - 11) + ' ';
        ddd = '(' + tel.slice(-11, -9) + ') ';
        num = tel.slice(-9, -4) + '-' + tel.slice(-4);
    } else if (tel.length === 11) {
        ddd = '(' + tel.slice(0, 2) + ') ';
        num = tel.slice(2, 7) + '-' + tel.slice(7);
    } else if (tel.length === 10) {
        ddd = '(' + tel.slice(0, 2) + ') ';
        num = tel.slice(2, 6) + '-' + tel.slice(6);
    } else {
        num = tel;
    }
    return `${ddi}${ddd}${num}`;
}


    const boletosDisponiveisIndices = indicesBoletosDisponiveis();

    return (
        <div className="dashboard">
            <div className="dashboard-content">
                <div className="dashboard-painel boletos-painel">
                    <h3 className="titulo">Boletos</h3>
                    <div className="topo-desc">
                        <p className="texto">
                            Todos os seus boletos em aberto e vencidos. Você
                            também pode ver seus boletos anteriores através dos
                            filtros.
                        </p>
                        <button
                            className="download-btn"
                            onClick={baixarBoletosSelecionados}
                        >
                            <FiDownload /> Baixar boletos (
                            {selectedBoletos.length})
                        </button>
                    </div>
                    <div className="boletos-filtros">
                        <input
                            type="text"
                            placeholder="Boleto"
                            value={filtros.nrDuplicataIn}
                            onChange={handleBoletoChange}
                            className="input-filtro"
                        />
                        <button onClick={handleOpenDateModal} className="input-filtro filtro-data-btn">
                            Data de Emissão <FaChevronDown />
                            {(filtros.dtEmissaoDe || filtros.dtEmissaoAte) && <span className="filtro-ativo-indicador"></span>}
                        </button>

                        {/* Modal de Data */}
                        {showDateModal && (
                            <div className="modal-overlay">
                                <div className="modal-content">
                                    <h3>
                                        Selecione o intervalo de datas de
                                        emissão
                                    </h3>
                                    <div className="date-range-picker">
                                        <DatePicker
                                            selected={filtros.dtEmissaoDe}
                                            onChange={(date) =>
                                                handleDateChange(
                                                    date,
                                                    "dtEmissaoDe"
                                                )
                                            }
                                            className="input-filtro"
                                            placeholderText="Emissão De"
                                            dateFormat="dd/MM/yyyy"
                                            locale={ptBR}
                                        />
                                        <DatePicker
                                            selected={filtros.dtEmissaoAte}
                                            onChange={(date) => {
                                                handleDateChange(
                                                    date,
                                                    "dtEmissaoAte"
                                                );
                                            }}
                                            className="input-filtro"
                                            placeholderText="Emissão Até"
                                            dateFormat="dd/MM/yyyy"
                                            locale={ptBR}
                                        />
                                    </div>
                                    <div className="modal-buttons">
                                        <button
                                            className="download-btn"
                                            onClick={applyDateFilter}
                                        >
                                            Aplicar
                                        </button>
                                        <button
                                            className="download-btn"
                                            onClick={() =>
                                                clearDateFilter(
                                                    "dtEmissaoDe",
                                                    "dtEmissaoAte"
                                                )
                                            }
                                        >
                                            Limpar Filtro
                                        </button>
                                        <button
                                            className="download-btn"
                                            onClick={() => {
                                                clearDateFilter("dtEmissaoDe", "dtEmissaoAte");
                                                handleCloseDateModal();
                                            }}
                                        >
                                            Cancelar
                                        </button >{" "}
                                        {/* Botão para fechar o modal */}
                                    </div>
                                </div>
                            </div>
                        )}

                        <button onClick={handleOpenVencimentoModal} className="input-filtro filtro-data-btn">
                            Data de Vencimento <FaChevronDown />
                            {(filtros.dtVencimentoDe || filtros.dtVencimentoAte) && <span className="filtro-ativo-indicador"></span>}
                        </button>

                        {showVencimentoModal && (
                            <div className="modal-overlay">
                                <div className="modal-content">
                                    <h3>
                                        Selecione o intervalo de datas de
                                        vencimento
                                    </h3>
                                    <div className="date-range-picker">
                                        <DatePicker
                                            selected={filtros.dtVencimentoDe}
                                            onChange={(date) =>
                                                handleDateChange(
                                                    date,
                                                    "dtVencimentoDe"
                                                )
                                            }
                                            className="input-filtro"
                                            placeholderText="Vencimento De"
                                            dateFormat="dd/MM/yyyy"
                                            locale={ptBR}
                                        />
                                        <DatePicker
                                            selected={filtros.dtVencimentoAte}
                                            onChange={(date) => {
                                                handleDateChange(
                                                    date,
                                                    "dtVencimentoAte"
                                                );
                                            }}
                                            className="input-filtro"
                                            placeholderText="Vencimento Até"
                                            dateFormat="dd/MM/yyyy"
                                            locale={ptBR}
                                        />
                                    </div>
                                    <div className="modal-buttons">
                                        <button
                                            className="download-btn"
                                            onClick={applyVencimentoFilter}
                                        >
                                            Aplicar
                                        </button>
                                        <button
                                            className="download-btn"
                                            onClick={() =>
                                                clearDateFilter(
                                                    "dtVencimentoDe",
                                                    "dtVencimentoAte"
                                                )
                                            }
                                        >
                                            Limpar Filtro
                                        </button>
                                        <button
                                            className="download-btn"
                                            onClick={() => {
                                                clearDateFilter("dtVencimentoDe", "dtVencimentoAte");
                                                handleCloseVencimentoModal();
                                            }}
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <input
                            type="text"
                            placeholder="Nota Fiscal"
                            value={filtros.nrNfeIn}
                            onChange={handleNfeChange}
                            className="input-filtro"
                        />
                        <Select
                            className="filtroStatus"
                            value={options.filter(opt =>
                                Array.isArray(filtros.situacaoIn)
                                    ? filtros.situacaoIn.includes(opt.value)
                                    : filtros.situacaoIn === opt.value
                            )}
                            isMulti
                            name="nome"
                            options={options}
                            onChange={handleSituacaoChange}
                            placeholder="Status"
                        />


                    </div>

                    {isLoading ? (
                        <div className="loading-container">
                            <img src={logo} alt="GAM" className="loading-logo" />
                            <div className="spinner"></div>
                            <p>Carregando lista de Boletos...</p>
                        </div>
                    ) : (
                        <div className="boletos-lista">
                            {boletos.length === 0 ? (
                                <p className="mensagem-vazia">Sem informações no momento para os parâmetros informados.</p>
                            ) : (
                                <table className="boletos-tabela">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={
                                                        handleSelectAllBoletos
                                                    }
                                                    checked={
                                                        boletosDisponiveisIndices.length > 0 &&
                                                        boletosDisponiveisIndices.every((index) =>
                                                            selectedBoletos.includes(index)
                                                        )
                                                    }
                                                />
                                            </th>
                                            <th>CNPJ</th>
                                            <th> Nº Boleto/Parcela </th>
                                            <th className="sortable-header" onClick={() => handleSort('DT_EMISSAO')}>
                                                Emissão
                                                {filtros.orderBy === 'DT_EMISSAO' && (filtros.fatorOrdenacao === 'ASC' ? ' ▲' : ' ▼')}
                                            </th>
                                            <th className="sortable-header" onClick={() => handleSort('DT_VENCIMENTO')}>
                                                Vencimento
                                                {filtros.orderBy === 'DT_VENCIMENTO' && (filtros.fatorOrdenacao === 'ASC' ? ' ▲' : ' ▼')}
                                            </th>
                                            <th className="sortable-header" onClick={() => handleSort('SALDO')}>
                                                Valor
                                                {filtros.orderBy === 'SALDO' && (filtros.fatorOrdenacao === 'ASC' ? ' ▲' : ' ▼')}
                                            </th>
                                            <th>Status</th>
                                            <th>Pix copia e cola</th>
                                            <th>Linha Digitavel</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.map((boleto, index) => (
                                            <React.Fragment key={index}>
                                                <tr
                                                    onClick={() =>
                                                        toggleRow(
                                                            index +
                                                            indexOfFirstRecord
                                                        )
                                                    }
                                                    className={
                                                        expandedRows.includes(
                                                            index +
                                                            indexOfFirstRecord
                                                        )
                                                            ? "expanded"
                                                            : ""
                                                    }
                                                >
                                                    <td>
                                                        <span
                                                            className={isDeposito(boleto) ? "copiar-btn-tooltip" : undefined}
                                                            title={isDeposito(boleto) ? TOOLTIP_CHECKBOX_DEPOSITO : undefined}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleSelectBoleto(
                                                                        index +
                                                                        indexOfFirstRecord
                                                                    );
                                                                }}
                                                                checked={selectedBoletos.includes(
                                                                    index +
                                                                    indexOfFirstRecord
                                                                )}
                                                                disabled={!boletoDisponivelParaDownload(boleto)}
                                                            />
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {formatCNPJ(boleto.cnpj)}
                                                    </td>
                                                    <td>
                                                        {boleto.nrDuplicata > 0 ? (
                                                            boletoDisponivelParaDownload(boleto) ? (
                                                                <a
                                                                    href="#"
                                                                    className={`boleto-link ${boleto.situacaoBoleto === "VENCIDO"
                                                                        ? "boleto-vencido"
                                                                        : boleto.situacaoBoleto === "PAGO"
                                                                            ? "boleto-pago"
                                                                            : ""
                                                                        }`}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        visualizarBoleto(boleto);
                                                                    }}
                                                                >
                                                                    {boleto.nrDuplicata}/{boleto.parcela}
                                                                </a>
                                                            ) : (
                                                                <span
                                                                    className={`boleto-numero ${boleto.situacaoBoleto === "VENCIDO"
                                                                        ? "boleto-vencido"
                                                                        : boleto.situacaoBoleto === "PAGO"
                                                                            ? "boleto-pago"
                                                                            : ""
                                                                        }`}
                                                                >
                                                                    {boleto.nrDuplicata}/{boleto.parcela}
                                                                </span>
                                                            )
                                                        ) : (
                                                            boleto.cdPedido
                                                        )}
                                                    </td>

                                                    <td>{boleto.dtEmissao}</td>
                                                    <td>{boleto.dtVencimento}</td>
                                                    <td>
                                                        {boleto.sdDuplicata
                                                            ? `R$ ${boleto.sdDuplicata.toLocaleString(
                                                                "pt-BR",
                                                                {
                                                                    minimumFractionDigits: 2,
                                                                }
                                                            )}`
                                                            : "R$ 0,00"}
                                                    </td>
                                                    <td className={`boleto-link ${boleto.situacaoBoleto === "VENCIDO"
                                                        ? "boleto-vencido"
                                                        : boleto.situacaoBoleto === "PAGO"
                                                            ? "boleto-pago"
                                                            : ""
                                                        }`}>
                                                        {boleto.situacaoBoleto === 'AVENCER' ? 'A VENCER' : boleto.situacaoBoleto}
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={isDeposito(boleto) ? "copiar-btn-tooltip" : undefined}
                                                            title={isDeposito(boleto) ? TOOLTIP_PIX_DEPOSITO : undefined}
                                                        >
                                                            <button
                                                                className="copiar-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    copiarQrCode(boleto.dsQrCode);
                                                                }}
                                                                disabled={isDeposito(boleto) || !boleto.dsQrCode || boleto.situacaoBoleto === 'PAGO'}
                                                            >
                                                                Copiar
                                                            </button>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={isDeposito(boleto) ? "copiar-btn-tooltip" : undefined}
                                                            title={isDeposito(boleto) ? TOOLTIP_LINHA_DEPOSITO : undefined}
                                                        >
                                                            <button
                                                                className="copiar-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    copiarLinhaDigitavel(boleto.dsLinhaDigitavel);
                                                                }}
                                                                disabled={isDeposito(boleto) || !boleto.dsLinhaDigitavel || boleto.situacaoBoleto === 'PAGO'}
                                                            >
                                                                Copiar
                                                            </button>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="toggle-details">
                                                            {expandedRows.includes(
                                                                index +
                                                                indexOfFirstRecord
                                                            ) ? (
                                                                <GoChevronUp />
                                                            ) : (
                                                                <GoChevronDown />
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>

                                                {expandedRows.includes(
                                                    index + indexOfFirstRecord
                                                ) && (
                                                        <tr className="expanded">
                                                            <td colSpan="10">
                                                                <div className="expanded-details">
                                                                    <table
                                                                        style={{
                                                                            width: "100%",
                                                                        }}
                                                                    >
                                                                        <tbody>
                                                                            <tr>
                                                                                <th>Nº Nfes:</th>
                                                                                <th>Abatimentos:</th>
                                                                                <th>Valor Original</th>
                                                                                {isDeposito(boleto) && (
                                                                                <th>Forma de Pagamento:</th>)}
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{boleto.nFs || "N/A"}</td>
                                                                                <td>{boleto.abatimento ? `R$ ${boleto.abatimento.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}` : "R$ 0,00"}</td>
                                                                                <td>{boleto.vlDuplicata ? `R$ ${boleto.vlDuplicata.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}` : "R$ 0,00"}</td>
                                                                                {isDeposito(boleto) && (<td>Depósito</td>)}
                                                                            </tr> 
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                    {/* Pagination controls */}
                    <div className="pagination">
                        <button
                            className="arrow-btn"
                            onClick={() => goToPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <FaChevronLeft />
                        </button>

                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                onClick={() => goToPage(index + 1)}
                                className={`page-btn ${currentPage === index + 1 ? "active" : ""
                                    }`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            className="arrow-btn"
                            onClick={() => goToPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <FaChevronRight />
                        </button>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>✖</button>
                        {isModalLoading ? (
                            <div className="loading-container" style={{ width: '100%', height: '500px', border: 'none' }}>
                                <div className="spinner"></div>
                                <p>Aguardando carregamento do PDF...</p>
                            </div>
                        ) : (
                            modalContent && (
                                <iframe
                                    src={modalContent}
                                    style={{ width: '100%', height: '500px', border: 'none' }}
                                    title="Danfe PDF"
                                />
                            )
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Boletos;
